import type { ParticipanteImportado } from './api/participantes';

const CABECALHO_DO_CSV = ['matricula', 'nome', 'grupo', 'lider', 'codigo'];

/**
 * Uma célula do CSV (separador `;`, como o Excel em português abre): entre aspas quando tem `;`,
 * aspas ou quebra de linha, e sem poder virar fórmula no Excel — o que começa com `=`, `+`, `-` ou
 * `@` ganha um apóstrofo na frente (nome vem de uma planilha qualquer).
 */
function celula(valor: string): string {
    const seguro = /^[=+\-@\t\r]/.test(valor) ? `'${valor}` : valor;
    return /[;"\r\n]/.test(seguro) ? `"${seguro.replace(/"/g, '""')}"` : seguro;
}

/** O arquivo para entregar os códigos: uma linha por pessoa criada, na ordem da planilha. */
export function montarCsvDeCodigos(criados: ParticipanteImportado[]): string {
    const linhas = criados.map((pessoa) =>
        [pessoa.matricula, pessoa.nome, pessoa.grupo_id ?? '', pessoa.lider ? 'sim' : 'não', pessoa.codigo ?? '']
            .map(celula)
            .join(';'),
    );
    return [CABECALHO_DO_CSV.join(';'), ...linhas].join('\r\n') + '\r\n';
}

const doisDigitos = (valor: number) => String(valor).padStart(2, '0');

/** `codigos-<turma>-AAAAMMDD-HHMMSS.csv`, no horário de quem baixa. */
export function nomeDoArquivoDeCodigos(turmaId: string, agora: Date = new Date()): string {
    const data = `${agora.getFullYear()}${doisDigitos(agora.getMonth() + 1)}${doisDigitos(agora.getDate())}`;
    const hora = `${doisDigitos(agora.getHours())}${doisDigitos(agora.getMinutes())}${doisDigitos(agora.getSeconds())}`;
    return `codigos-${turmaId}-${data}-${hora}.csv`;
}

/** Baixa o texto como arquivo; o BOM faz o Excel abrir os acentos certos. */
export function baixarCsv(nome: string, conteudo: string): void {
    const arquivo = new Blob(['﻿', conteudo], { type: 'text/csv;charset=utf-8' });
    const endereco = URL.createObjectURL(arquivo);
    const ancora = document.createElement('a');
    ancora.href = endereco;
    ancora.download = nome;
    document.body.appendChild(ancora);
    ancora.click();
    ancora.remove();
    // Soltar na hora cancelaria o download em alguns navegadores.
    setTimeout(() => URL.revokeObjectURL(endereco), 1_000);
}
